import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import OrderNumber from './component';

const orderNumber = {
  id: 'markAsShipped.columns.orderNumber',
  defaultMessage: 'Order #',
};

const GetName = () => {
  const intl = useIntl();

  return intl.formatMessage(orderNumber);
};

export default {
  id: 'mark-as-shipped-order-number',
  index: 0,
  isDragable: false,
  minWidth: 100,
  width: 200,
  nonsortable: true,
  getName: () => <GetName />,
  name: <FormattedMessage {...orderNumber} />,
  render: (data) => {
    return <OrderNumber fulfillmentPlanId={data.id} />;
  },
};
